import request from '@teetsh/app/src/utils/request';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import { AxiosError } from 'axios';

export interface RegisterGoogleRequestPayload {
  tokenId: string;
  edtTemplateId?: string;
  sequenceTemplateId?: string;
  programmationTemplateId?: string;
  edtTemplateDocumentId?: string;
  sequenceTemplateDocumentId?: string;
  programmationTemplateDocumentId?: string;
  parrainageToken?: string;
  shareToken?: string;
  shareEntityId?: string;
  shareEntityType?: string;
}

export function useRegisterGoogle() {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation<
    any,
    AxiosError,
    RegisterGoogleRequestPayload
  >({
    mutationFn: ({
      tokenId,
      edtTemplateId,
      sequenceTemplateId,
      programmationTemplateId,
      edtTemplateDocumentId,
      sequenceTemplateDocumentId,
      programmationTemplateDocumentId,
      parrainageToken,
      shareToken,
      shareEntityId,
      shareEntityType,
    }) =>
      request('/register-google', {
        method: 'POST',
        headers: { Authorization: `Bearer ${tokenId}` },
        body: {
          edtTemplateId,
          sequenceTemplateId,
          programmationTemplateId,
          edtTemplateDocumentId,
          sequenceTemplateDocumentId,
          programmationTemplateDocumentId,
          parrainageToken,
          shareToken,
          shareEntityId,
          shareEntityType,
        },
      }),

    onSuccess: response => {
      localStorage.setItem('id_token', response.token);
      localStorage.setItem('email', response.email);
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
  });
  return mutateAsync;
}
